import { useContext, useEffect } from "react"
import { stateContext } from "./ctx"
import { icons } from "./icons"

const Theme = () => {
    const {theme,setTheme} = useContext(stateContext)

    const toggleTheme = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
    }

    useEffect(()=>{
        localStorage.setItem('CSSHEROMESHERTHEME',theme)
    },[theme])
    

    return <div className='flex relative hover:dark:bg-slate-800 hover:bg-mute-100 cursor-pointer p-3 gap-3 rounded-xl' onClick={toggleTheme}>Theme{icons[theme === 'dark' ? 'sun' : 'moon']}</div>
}

export default Theme